<template>
  <!-- Header -->
  <Header_AS @on-change-main-page="getMainPageData()" />

  <!-- SECCION 1-->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div id="slide">
          <div
            class="item active"
            :style="{
              backgroundImage: seccionUnoFondo ? `url(${seccionUnoFondo})` : '',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }"
          ></div>
        </div>
      </div>

      <div class="sobrefondo"></div>

      <div class="container px-5 container-banner-img">
        <div class="stack-badges">
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-secundario  d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge d-none d-md-block"
          />
        </div>
      </div>

      <div class="container px-5 banner-text-wrapper">
        <div v-if="isMobile" class="stack-badges-mobile">
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
        </div>
        <div class="banner-text-inner">
          <div
            :class="['text-start', { aos: !isMobile }]"
            :data-aos="!isMobile ? 'fade-up' : null"
            data-aos-duration="500"
          >
            <div class="banner-typewriter">
              <span>{{ currentTypedText }}</span>
            </div>
            <h2 class="banner-title">{{ currentContentText }}</h2>
          </div>
        </div>
        <div
          class="input-group search-input bg-white bg-opacity-75 px-3 py-2 rounded-pill shadow-sm d-none d-sm-flex"
        >
          <input
            type="text"
            class="form-control border-0 bg-transparent text-dark"
            placeholder="Encuentra tu puesto ideal. Busca aquí"
            aria-label="Buscar"
            v-model="palabra_clave"
          />
          <span
            class="input-group-text bg-transparent border-0"
            @click="onSearchClick"
          >
            <i class="bx bx-search text-white fs-5 align-middle"></i>
          </span>
        </div>
      </div>
    </div>
  </section>
  <!-- END SECCION 1 -->

    <!-- SECCION 2-->
  <section id="quienes-somos" class="section-who-we-are">
    <div class="container px-5">
      <div class="row">
        <!-- Texto izquierda -->
        <div class="col-xs-12 col-sm-12 col-ms-6 col-lg-6 ps-5 pe-4">
          <div class="aos" data-aos="fade-up" data-aos-duration="500">
            <div class="container-text-who-we-are who-we-are-copy">
              <h2 class="title-who-we-are">
                ¿Quiénes somos?
              </h2>

              <p class="description-who-we-are">
                {{ seccionDosTexto }}
              </p>
            </div>
          </div>
        </div>

        <!-- Imagen derecha -->
        <div class="col-xs-12 col-sm-12 col-ms-6 col-lg-6">
          <div
            class="d-flex justify-content-center pt-3"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <img
              v-if="seccionDosImagen"
              :src="seccionDosImagen"
              alt="Imagen sección 2"
              class="img-who-we-are"
            />
          </div>
        </div>
      </div>
    </div>

    <img
      class="img-design-left"
      src="@/assets/talento_agv/img/home/patron-left.png"
      alt=""
    />
    <img
      class="img-design-right"
      src="@/assets/talento_agv/img/home/patron-right.png"
      alt=""
    />
  </section>
  <!-- END SECCION 2 -->

  <!-- SECCION 3 -->
  <section class="section-our-mission">
  <div
    class="container px-5 position-relative content-wrapper"
    data-aos="fade-down"
    data-aos-duration="500"
  >
    <div class="row" v-if="seccionTresTitulo">
      <div class="col-12">
        <div class="section-header-our-mission text-center aos">
          <h2 class="title-our-mission text-white mb-2">
            Nuestra Misión
          </h2>
          <p class="text-white">{{ seccionTresTitulo }}</p>
        </div>
      </div>
    </div>

    <div id="company-slider" class="aos text-center">
      <div class="row justify-content-center gy-4 row-indicadores">
        <div
          v-for="(item, i) in seccionTresIndicadores"
          :key="i"
          class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center aos"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <div class="section-our-mission-counter mx-auto text-center">
            <h1 class="indicador-num">
              <template v-if="item.pieces && item.pieces.val && item.pieces.val.length">
                <vue3-autocounter
                  class="counter-up"
                  ref="counter"
                  :startAmount="0"
                  :delay="6"
                  :endAmount="parseInt(item.pieces.val[0])"
                  :duration="3"
                  separator=","
                  :autoinit="true"
                />
                <span class="indicador-sufijo">{{ item.pieces.pic[1] || '' }}</span>
              </template>
              <template v-else>
                {{ item.value }}
              </template>
            </h1>

            <div class="section-our-mission-counter-description" style="min-width: 200px">
              <p>{{ item.subtitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sobrefondo"></div>
</section>

  <!-- END SECCION 3 -->

  <!-- SECCION 4 -->
  <section class="section-our-culture">
    <div class="container px-5">
      <div class="row">
        <div
          class="section-header-our-culture aos text-center d-flex justify-content-center"
          data-aos="fade-up"
        >
          <h3 class="section-title w-75">
            <img
              src="@/assets/talento_agv/img/arrow.png"
              alt=""
              class="arrow-icon-culture"
            />
            Vivimos nuestra
            <span style="color: #00ccff">#CulturaAgrovision</span>
            en nuestros
            <span style="color: #1957d1">campos, packing y oficinas</span>
          </h3>
        </div>
      </div>
        <div class="container-carousel-cultura">
        <Carousel :autoplay="3000" :wrap-around="true">
          <Slide v-for="(slide, i) in seccionCuatroCarrusel" :key="i">
            <div class="grid-container">
              <div
                v-for="(img, index) in slide.img"
                :key="index"
                class="grid-item"
              >
                <img :src="img.ruta" alt="img-carousel" />
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination class="custom-dots" />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
  <!-- END SECCION 4 -->

  <!-- SECCION 5 -->
  <section class="section-video" v-if="seccionCincoVideo">
    <video :src="seccionCincoVideo" autoplay muted loop></video>
    <div class="sobrefondo"></div>

    <div class="section-video-container-video">
      <div class="d-flex justify-content-center align-items-center">
        <button
          class="btn btn-white btn-rounded border-0 px-4 btn-play-video"
          data-bs-toggle="modal"
          href="#videoHome"
          @click.prevent="openModalVideoHome"
        >
          Ver el video
        </button>
      </div>
    </div>
  </section>

  <!-- Modal Video SECCION 5 -->
  <div
    class="modal fade"
    id="videoHome"
    data-bs-backdrop="true"
    data-bs-keyboard="true"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel"
    tabindex="-1"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content modal-transparent">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModalVideoHome"
          ></button>
        </div>
        <div class="modal-body">
          <video
            ref="videoHomeRef"
            :src="seccionCincoVideo"
            preload="auto"
            controls
            style="width: 100%; height: 100%"
          ></video>
        </div>
      </div>
    </div>
  </div>
  <!-- END MODAL SECCION 5 -->

   <!-- SECCION 6 -->
  <!-- START SECCION 6 -->
  <section class="section-agrovision-values">
    <div class="container px-5" data-aos="fade-down" data-aos-duration="500">
      <div class="row">
        <div class="section-header-agrovision-values text-center aos">
          <h3 class="section-title">Valores con Visión</h3>
        </div>
      </div>

      <!-- 🔹 Valores dinámicos (Desktop) -->
      <div v-if="!isMobile" class="d-flex justify-content-center text-center gap-4 values-grid">
        <div
          v-for="(item, i) in seccionSeisValores"
          :key="i"
          class="value-card"
        >
          <img
            v-if="item.s3_url"
            :src="item.s3_url"
            alt="valor agrovision"
            class="value-icon"
            loading="lazy"
          />
          <div class="value-caption">
            <div class="value-title">{{ item.titulo_valor }}</div>
            <div class="value-subtitle">{{ item.frase_valor }}</div>
          </div>
        </div>
      </div>

      <!-- 🔹 Valores dinámicos (Mobile Carousel) -->
      <div v-else class="container-carousel-valores">
        <Carousel :items-to-show="1" :wrap-around="true" :autoplay="3000">
          <Slide v-for="(item, i) in seccionSeisValores" :key="i">
            <div class="value-card mx-auto">
              <img
                v-if="item.s3_url"
                :src="item.s3_url"
                alt="valor agrovision"
                class="value-icon"
                loading="lazy"
              />
              <div class="value-caption">
                <div class="value-title">{{ item.titulo_valor }}</div>
                <div class="value-subtitle">{{ item.frase_valor }}</div>
              </div>
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>
  </section>
  <!-- END SECCION 6 -->

  <section class="section-header-news">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-news-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            {{ $t("Noticias que nos llenan de orgullo") }}
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>

  <!-- News -->
  <section class="section-content-news">
    <div class="container px-5">
      <div class="row">
        <div
          v-for="(item, index) in seccionSieteNoticias"
          :key="index"
          class="col-md-4 col-12 mb-5"
        >
          <component
            :is="item.url ? 'a' : 'div'"
            :href="item.url || null"
            target="_blank"
            rel="noopener"
            class="card border-0 shadow-sm overflow-hidden custom-card text-decoration-none"
            :class="!item.url && 'is-disabled'"
          >
            <img :src="item.img" class="img-fluid" alt="Agrovision Noticia" />
            <div class="container-text-card text-white text-center p-3">
              <p class="mb-0 fw-semibold small">{{ item.title }}</p>
            </div>
          </component>
        </div>
      </div>

      <!-- Mostrar “Ver más” solo si hay más de 3 noticias -->
      <div
        v-if="seccionSieteNoticias.length > 3"
        class="col-12 d-flex align-items-center justify-content-center"
      >
        <div class="btn-news">
          <a
            :href="seccionSieteNoticias[0].url"
            target="_blank"
            >Ver más</a
          >
        </div>
      </div>
    </div>
  </section>

  <div class="section-footer-news"></div>
  <!-- Footer -->
  <Footer_AS />
  <!-- Button work -->
  <Button_work_AS :palabra_clave="palabra_clave" />
</template>

<style scoped>

.title-who-we-are {
  font-size: 2rem !important;
  line-height: 2.6 !important;
  font-weight: 600 !important;
}

.section-our-mission {
  position: relative;
}

.section-our-mission .container {
  position: relative;
  top: -3rem;
}

.title-our-mission {
  font-size: 2rem !important;
  line-height: 3.0 !important;
  font-weight: 600 !important;
  margin-bottom: 0.5rem !important;
}

.section-header-our-mission p {
  margin-bottom: 2rem;
}

.section-our-mission .row-indicadores {
  position: relative;
  top: 1.5rem;
}

.section-our-mission .content-wrapper {
  position: relative;
  top: -1rem;
}

/* indicadores: semibold y sin separaciones indeseadas */
.indicador-num {
  font-size: 48px;
  font-weight: 600; /* semibold */
  margin: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 0;
  white-space: nowrap;
}

.indicador-num .counter-up {font-weight: 600;}

.indicador-sufijo {
  margin-left: 0;
  font-weight: 600;
}

/* opcional: en móvil bájalo menos */
@media (max-width: 576px) {
  .section-our-mission .row-indicadores {
    top: 1rem;
  }
  .section-our-mission .content-wrapper {
    top: 1rem;
  }
  .section-our-mission .container {
    top: -1.5rem;
  }
}

/* Valores (desktop: fila única sin scrollbar) */
.values-grid{
  display: flex;
  flex-wrap: nowrap;                 /* 1 sola fila en desktop */
  justify-content: space-between;
  align-items: flex-start;
  gap: 48px;
  max-width: 1150px;
  margin: 0 auto;
  overflow: visible;
}

/* cada card ocupa el MISMO ancho para que todo alinee perfecto */
.value-card{
  flex: 0 0 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* iconos iguales */
.value-icon{
  width: 110px;
  height: 110px;
  object-fit: contain;
  display: block;
}

.value-caption{
  width: 100%;
  margin-top: 10px;
  background: #eaedf2;
  border-radius: 14px;
  padding: 10px 12px;
  text-align: center;
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* fuerza misma altura para todos los títulos y centra verticalmente */
.value-title{
  font-weight: 700;
  margin: 0;
  line-height: 1.15;
  min-height: 22px;
  white-space: nowrap;
}

/* subtítulo igual para todos */
.value-subtitle{
  margin: 0;
  font-size: 0.95rem;
  color: #5f6b7a;
  line-height: 1.15;
}

/* Responsivo: cuando el viewport es más angosto, convertimos valores a carrusel horizontal */
@media (max-width: 768px) {
  .values-grid{
    display: flex;
    overflow-x: auto;
    gap: 20px;
    padding: 12px 8px;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
  }
  .value-card{
    flex: 0 0 70%;
    scroll-snap-align: center;
    min-width: 220px;
  }
  .value-icon{ width: 88px; height: 88px; }
  .indicador-num { font-size: 36px; }
}


.sobrefondo {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.section-our-mission .content-wrapper,
.banner-text-wrapper { z-index: 2; }

/* pequeños ajustes responsive para el banner y texto */
.banner-title {
  font-size: clamp(1.6rem, 2.6vw, 2.4rem);
  font-weight: 700;
}

/* Modal video estilo (opcional) */
.modal-transparent .modal-content {
  background: transparent;
  border: 0;
}
.modal-transparent .modal-body {
  padding: 0;
}
.modal-header {
  padding-bottom: 1rem;  
}
.modal-header .btn-close {
  top: -0.5rem;
  right: -0.5rem;
}


</style>

<script>
import { router } from "@/router";
import "aos/dist/aos.css";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import AOS from "aos";

import axiosIns from "@/plugins/axios.js";
import Button_work_AS from "./components/Button_work_AS.vue";
import defaultVideoHome from "@/assets/talento_agv/video/welcome_agrovision.mp4";
import Footer_AS from "./components/Footer_AS.vue";
import Header_AS from "./components/Header_AS.vue";
import fondo01 from "@/assets/talento_agv/img/resources_talento/Principal/Principal-03.webp";
import { ref } from "vue";  

export default {
  name: "InicioASComponent",
  components: {
    Button_work_AS,
    Carousel,
    Footer_AS,
    Header_AS,
    Pagination,
    Slide,
  },
  data() {
    return {
      dataNoticia: [],
      dataCulturaCarousel: [],
      videoControl: null,
      dataImagen: [],
      currentImageIndex: 0,
      currentTypedText: "",
      currentContentText: "",
      typingSpeed: 100,
      typingIndex: 0,
      effectText: [],
      section_one: [],
      section_two: [],
      section_three: [],
      section_four: [],
      section_five: [],
      section_six: [],
      section_seven: [],
      section_eight: {
        indicadores: [],
      },
      section_ten: [],

      dataTableValues: [],
      dataTableCards: [],

      language: null,
      textLenguage: "es",
      palabra_clave: "",
      defaultVideoHome,
      isMobile: window.innerWidth < 768,

      dataImagen_default: [
        fondo01,
      ],

      // START SECCION 1
        seccionUnoFondo: null,
        seccionUnoFrases: [],
        seccionUnoContenido: "",
      // END SECCION 1

      // START SECCION 2
        seccionDosTexto: "",
        seccionDosImagen: null,

      // END SECCION 2

      // START SECCION 3
        seccionTresTitulo: "",
        seccionTresIndicadores: [],
      // END SECCION 3

      // START SECCION 4
        seccionCuatroCarrusel: [],
      // END SECCION 4

      // START SECCION 5
        seccionCincoVideo: null,
      // END SECCION 5

      // START SECCION 6
      seccionSeisValores: [],
      // END SECCION 6

      // START SECCION 7
      seccionSieteNoticias: [],
      // END SECCION 7

      // internal modal instance
      _videoModalInstance: null,
    };
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this._handleKeydownForModal);
    if (this.toggleImages) {
      clearInterval(this.toggleImages);
    }
    // dispose bootstrap modal if exists
    try {
      if (this._videoModalInstance && typeof this._videoModalInstance.dispose === 'function') {
        this._videoModalInstance.dispose();
      }
    } catch (e) {}
  },
  async mounted() {

    await this.getInicioSeccionUno();
    await this.getInicioSeccionDos();
    await this.getInicioSeccionTres();
    await this.getInicioSeccionCuatro();
    await this.getInicioSeccionCinco();
    await this.getInicioSeccionSeis();
    await this.getInicioSeccionSiete();

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    document.body.appendChild(script);
    this.toggleImages();
    this.startTypingEffect();

    AOS.init({ duration: 1000 });

    // Init Bootstrap modal instance for video (ensure bootstrap is loaded globally)
    try {
      const modalEl = document.getElementById("videoHome");
      if (modalEl && window.bootstrap && typeof window.bootstrap.Modal === "function") {
        this._videoModalInstance = new window.bootstrap.Modal(modalEl, {
          backdrop: true,
          keyboard: true,
        });

        // Pause video on hide
        modalEl.addEventListener("hidden.bs.modal", () => {
          const video = this.$refs.videoHomeRef;
          if (video) {
            try {
              video.pause();
              video.currentTime = 0;
            } catch (e) {}
          }
        });
      }
    } catch (e) {
      console.warn("No se pudo inicializar modal bootstrap (espera que bootstrap esté cargado):", e);
    }

    // Also add keydown listener to ensure ESC closes if bootstrap is not active
    window.addEventListener("keydown", this._handleKeydownForModal);
  },
  methods: {

    // START SECCION 1

    async getInicioSeccionUno() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionUno/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 1");

        const result = data.result || [];

        // 🔹 Fondo (toma el que tenga s3_url)
        const fondo = result.find(r => r.s3_url);
        this.seccionUnoFondo = fondo ? fondo.s3_url : null;

        // 🔹 Frases (los que tienen frases)
        this.seccionUnoFrases = result
          .filter(r => r.frases && r.frases.trim() !== "")
          .map(r => r.frases);

        // 🔹 Contenido principal
        const contenido = result.find(r => r.contenido_principal);
        this.seccionUnoContenido = contenido ? contenido.contenido_principal : "";

        // 🔹 Reasigna para el efecto de escritura
        this.effectText = this.seccionUnoFrases;
        this.currentContentText = this.seccionUnoContenido;
      } catch (err) {
        console.error("Error getInicioSeccionUno:", err);
      }
    },

    // END SECCION 1

    // START SECCION 2
    async getInicioSeccionDos() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionDos/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 2");

        const row = Array.isArray(data.result) ? data.result[0] : null;

        this.seccionDosTexto  = row?.parrafo_principal?.trim() || "";
        this.seccionDosImagen = row?.s3_url || null;
      } catch (e) {
        console.error("getInicioSeccionDos:", e);
        this.seccionDosTexto  = "";
        this.seccionDosImagen = null;
      }
    },

    // END SECCION 2


    // START SECCION 3
    async getInicioSeccionTres() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionTres/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 3");

        const rows = Array.isArray(data.result) ? data.result : [];

        // título/contenido principal (primero no vacío)
        const titulo = rows.find(r => (r.contenido_principal_tres || "").trim());
        this.seccionTresTitulo = titulo ? titulo.contenido_principal_tres.trim() : "";

        // indicadores: guardamos value (completo) y pieces (si existe número)
        this.seccionTresIndicadores = rows
          .filter(r => (r.indicador_principal || "").trim())
          .map(r => {
            const raw = r.indicador_principal.trim();
            return {
              value: raw,
              subtitle: (r.descripcion_indicador || "").trim(),
              pieces: this.extractNumber(raw),
            };
          });

          console.log(this.seccionTresIndicadores);
      } catch (e) {
        console.error("getInicioSeccionTres:", e);
        this.seccionTresTitulo = "";
        this.seccionTresIndicadores = [];
      }
    },
    // END SECCION 3

    // START SECCION 4
    async getInicioSeccionCuatro() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionCuatro/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 4");

        const rows = Array.isArray(data.result) ? data.result : [];

        // 🔹 Dividimos las imágenes en grupos de 3 para formar las "columnas"
        const imagenes = rows
          .map(r => r.s3_url)
          .filter(Boolean);

        const grupos = [];
        for (let i = 0; i < imagenes.length; i += 3) {
          grupos.push({
            img: imagenes.slice(i, i + 3).map(url => ({ ruta: url })),
          });
        }

        this.seccionCuatroCarrusel = grupos;
      } catch (e) {
        console.error("getInicioSeccionCuatro:", e);
        this.seccionCuatroCarrusel = [];
      }
    },

    // END SECCION 4

    // SECCION 5

    async getInicioSeccionCinco() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionCinco/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 5");

        const row = Array.isArray(data.result) ? data.result[0] : null;
        this.seccionCincoVideo = row?.s3_url || null;
      } catch (e) {
        console.error("getInicioSeccionCinco:", e);
        this.seccionCincoVideo = null;
      }
    },

    // END SECCION 5


    // SECCION 6

    async getInicioSeccionSeis() {
      try {
        const { data } = await axiosIns.get("/talentoagv/getInicioSeccionSeis/");
        if (data?.is_error) throw new Error(data.message || "Error obteniendo sección 6");

        const rows = Array.isArray(data.result) ? data.result : [];

        this.seccionSeisValores = rows.map(r => ({
          id: r.id_seccionseis,
          titulo_valor: (r.titulo_valor || "").trim(),
          frase_valor: (r.frase_valor || "").trim(),
          s3_url: r.s3_url || null,
        }));
      } catch (e) {
        console.error("getInicioSeccionSeis:", e);
        this.seccionSeisValores = [];
      }
    },
    // END SECCION 6


    // SECCION 7

    async getInicioSeccionSiete () {
      try {
        const { data } = await axiosIns.get('/talentoagv/getInicioSeccionSiete/')
        if (data?.is_error) throw new Error(data.message || 'Error obteniendo sección 7')

        const rows = Array.isArray(data.result) ? data.result : []

        this.seccionSieteNoticias = rows.map(r => ({
          title: (r.title || '').trim(),
          url: this._sanitizeUrl(r.text_url),
          img: r.s3_url || null,
        }))
      } catch (e) {
        console.error('getInicioSeccionSiete:', e)
        this.seccionSieteNoticias = []
      }
    },

    _sanitizeUrl (u) {
      if (!u) return null
      const s = String(u).trim()
      if (/^https?:\/\//i.test(s)) return s
      return null
    },

    // END SECCION 7

    async getMainPageData() {
      const yo = this;
      const config = {
        method: "get",
        url: "/talentoagv/getMainPageData/",
      };

      if (this.$store.getters.currentPublicLanguage == "es") {
        yo.language = "1";
      } else if (this.$store.getters.currentPublicLanguage == "en") {
        yo.language = "2";
      }

      await axiosIns(config)
        .then(function (response) {
          if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            let phrases = [];
            let indicadores = [];
            let sliders = [];
            let content = { id: 0, title: "" };
            let carousel = [];
            let notices = [];
            for (let r of resultado) {
              if (r["idlanguage"] == yo.language) {
                if (r["section"] == "cero" && r["idpage"] == "1") {
                  if (r.text != "" && r.text != null) {
                    phrases.push(r.text);
                  }
                  if (r.text_two != "" && r.text_two != null) {
                    content = { id: r.idcontent, title: r.text_two };
                  }
                  yo.section_zero = r;
                }
                if (r["section"] == "uno" && r["idpage"] == "1") {
                  yo.section_one = r;
                } else if (r["section"] == "dos" && r["idpage"] == "1") {
                  yo.section_two = r;
                } else if (r["section"] == "tres" && r["idpage"] == "1") {
                  yo.section_three = r;
                } else if (r["section"] == "cuatro" && r["idpage"] == "1") {
                  yo.section_four = r;
                } else if (r["section"] == "cinco" && r["idpage"] == "1") {
                  yo.section_five = r;
                } else if (r["section"] == "seis" && r["idpage"] == "1") {
                  yo.section_six = r;
                } else if (r["section"] == "siete" && r["idpage"] == "1") {
                  sliders.push(r);
                  yo.dataImagen.push(r.s3_url_two);
                } else if (r["section"] == "ocho" && r["idpage"] == "1") {
                  if (r.title_two != "" && r.title_two != null) {
                    indicadores.push({
                      title: r.title_two,
                      subtitle: r.subtitle_two,
                      id: r.idcontent,
                      pieces: yo.extractNumber(r.title_two),
                    });
                  } else {
                    yo.section_eight = r;
                  }
                } else if (r["section"] == "nueve" && r["idpage"] == "1") {
                  if (carousel.length < 6) {
                    carousel.push({ ruta: r.s3_url_two });
                  } else {
                    yo.dataCulturaCarousel.push({
                      columna: yo.dataCulturaCarousel.length + 1,
                      img: carousel,
                    });
                    carousel = [];
                    carousel.push({ ruta: r.s3_url_two });
                  }
                } else if (r["section"] == "diez" && r["idpage"] == "1") {
                  yo.section_ten = r;
                } else if (r["section"] == "once" && r["idpage"] == "1") {
                  notices.push({
                    img: r.s3_url,
                    title: r.title,
                    url: r.subtitle,
                    description: r.text,
                  });
                }
              }
            }
            yo.section_eight["indicadores"] = indicadores;
            yo.section_seven = sliders;
            yo.effectText = phrases
            yo.currentContentText = content.title;

            yo.dataNoticia = notices;
            if (carousel.length != 0) {
              yo.dataCulturaCarousel.push({
                columna: yo.dataCulturaCarousel.length + 1,
                img: carousel,
              });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {});
    },

    async getValues() {
      const yo = this;
      yo.dataTableValues = [];
      const config = {
        method: "get",
        url: "/talentoagv/readValues/",
      };

      await axiosIns(config)
        .then(function (response) {
          if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            for (let r of resultado) {
              if (r["key_idioma_id"] == yo.language) {
                yo.dataTableValues.push(r);
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {});
    },

    async getCards() {
      const yo = this;
      yo.dataTableCards = [];
      const config = {
        method: "get",
        url: "/talentoagv/readCards/",
      };

      await axiosIns(config)
        .then(function (response) {
          if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            for (let r of resultado) {
              if (r["key_idioma_id"] == yo.language) {
                yo.dataTableCards.push(r);
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {});
    },

    extractNumber(val) {
      if (!val || typeof val !== "string") return { val: [], pic: [val || ""] };
      let matches = val.match(/\d+/g) || [];
      // split keeping non-number parts
      // replace digits with a token and split to get surrounding strings
      const token = "§§§";
      const replaced = val.replace(/\d+/g, token);
      const pic = replaced.split(token);
      return { val: matches, pic: pic };
    },

    toggleImages() {
      if (this.dataImagen_default.length <= 1) return;
      this._toggleInterval = setInterval(() => {
        this.currentImageIndex =
          (this.currentImageIndex + 1) % this.dataImagen_default.length;
      }, 3000);
    },

    startTypingEffect() {
      if (!this.effectText || this.effectText.length === 0) return;
      this.typingIndex = 0;
      this.currentTypedText = "";
      this.typeText();
    },

    typeText() {
      const currentText = this.effectText[this.typingIndex] || "";
      let charIndex = 0;
      const typingInterval = setInterval(() => {
        if (charIndex < currentText.length) {
          this.currentTypedText += currentText[charIndex];
          charIndex++;
        } else {
          clearInterval(typingInterval);
          setTimeout(() => {
            this.currentTypedText = "";
            this.typingIndex = (this.typingIndex + 1) % this.effectText.length;
            this.typeText();
          }, 2000);
        }
      }, this.typingSpeed);
    },

    openModalVideoHome() {
      try {
        if (this._videoModalInstance && typeof this._videoModalInstance.show === 'function') {
          this._videoModalInstance.show();
        } else {
          // fallback: trigger via attribute
          const el = document.getElementById('videoHome');
          if (el) el.classList.add('show');
        }
      } catch (e) {
        console.warn('Error abriendo modal video:', e);
      }
    },

    closeModalVideoHome() {
      // close bootstrap modal instance if exists
      try {
        if (this._videoModalInstance && typeof this._videoModalInstance.hide === 'function') {
          this._videoModalInstance.hide();
        } else {
          const el = document.getElementById('videoHome');
          if (el) el.classList.remove('show');
        }
      } catch (e) {
        console.warn('Error cerrando modal video:', e);
      }

      const video = this.$refs.videoHomeRef;
      if (video) {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      }
    },

    _handleKeydownForModal(e) {
      if (e.key === "Escape" || e.key === "Esc") {
        // hide modal if open
        try {
          if (this._videoModalInstance) {
            // check if modal currently shown using bootstrap's modal element class
            const el = document.getElementById('videoHome');
            if (el && el.classList.contains('show')) {
              this._videoModalInstance.hide();
            }
          }
        } catch (err) {}
      }
    },

    onSearchClick() {
      router.push(
        "/dashboard_ofertas_laborales?keyword=" +
          encodeURIComponent(this.palabra_clave)
      );
    },

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/inicio_AS.css"></style>
<style scoped>
/* centrar el bloque de métricas y evitar que “se pegue” a la izquierda */
.metrics-wrap {
  max-width: 980px;     /* ajusta a gusto (900–1100px funciona bien) */
}

/* opcional: ancho mínimo para que cada descripción no “salte” */
.feature-content-description { min-width: 200px; }
</style>
